import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Home, Image, ShoppingBag, User, Bell } from 'lucide-react';
import PWAInstallPrompt from './PWAInstallPrompt';

const PWALayout = () => {
  const location = useLocation();

  const navItems = [
    { icon: Home, label: 'Home', path: '/app' },
    { icon: Image, label: 'Galleries', path: '/app/galleries' },
    { icon: ShoppingBag, label: 'Orders', path: '/app/orders' },
    { icon: User, label: 'Account', path: '/app/account' },
  ];

  const isActive = (path) => {
    if (path === '/app') return location.pathname === '/app';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-stone-50 pb-20">
      {/* Main Content */}
      <main className="max-w-lg mx-auto">
        <Outlet />
      </main>

      {/* Install Prompt */}
      <PWAInstallPrompt />

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 safe-area-pb z-50">
        <div className="max-w-lg mx-auto flex justify-around py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center py-2 px-4 rounded-lg transition-colors ${
                  active 
                    ? 'text-amber-600' 
                    : 'text-stone-500 hover:text-stone-700'
                }`}
              >
                <Icon className={`h-6 w-6 ${active ? 'stroke-2' : ''}`} />
                <span className="text-xs mt-1 font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default PWALayout;
